export const negativeStatuses = ["lag", "nervous", "memory-leak", "fire", "hacked", "disabled", "frail"];